/**
 * @file: 新增组件
 * @author: xiaolong.huang@dmall.com
 */

import Visit from '../visit';
import { runAddTaskQueue } from './runAddTaskQueue';
import { makeAddTaskQueue } from './makeAddTaskQueue';
import { runNormalInsert } from './normalInsert';

// 解决循环引用，往公共对象上挂
function mountApi() {
    Visit.Add = {
        runAddTaskQueue,
        makeAddTaskQueue,
        runNormalInsert
    };
}

export default {
    runAddTaskQueue,
    makeAddTaskQueue,
    runNormalInsert,
    mountApi
};
